import * as THREE from "three";

export function ledMaterial(color: number, horizontal: boolean): THREE.ShaderMaterial {
  return new THREE.ShaderMaterial({
    toneMapped: false,
    uniforms: { color: { value: new THREE.Color(color) }, time: { value: 0 }, horizontal: { value: Number(horizontal) } },
    vertexShader: /* glsl */`
      varying vec2 ledUv;
      void main() {
        ledUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: /* glsl */`
      uniform vec3 color;
      uniform float time, horizontal;
      varying vec2 ledUv;
      void main() {
        // Vertical LED gradient scrolls up its UVs, with a bright moving crest.
        float wave = pow(0.5 + 0.5 * cos((ledUv.y - time * 0.22) * 6.2831853), 3.0);
        // Horizontal bars breathe smoothly over 5 seconds, without hard cuts.
        float pulse = 0.5 - 0.5 * cos(time * 1.2566371);
        float strength = mix(wave, pulse, horizontal);
        vec3 crest = mix(color, vec3(1.0), (1.0 - horizontal) * pow(strength, 3.0) * 0.3);
        float brightness = mix(0.008 + strength * 0.992, 0.18 + strength * 0.82, horizontal);
        gl_FragColor = vec4(crest * brightness, 1.0);
        #include <colorspace_fragment>
      }
    `,
  });
}
